import { __assign } from 'tslib';
import React from 'react';
import cn from 'classnames';
import { Skeleton } from '../../../../skeleton/esm';
import { useTabs } from '../../hooks/use-tabs.js';
import { ScrollableContainer } from '../scrollable-container/Component.js';
import 'react-merge-refs';
import '../../../../shared/esm';
import 'compute-scroll-into-view';
import '../scroll-controls/Component.js';
import 'lodash/debounce';
import '../../../../icon-button/esm';
import '@alfalab/icons-glyph/ChevronLeftCompactSIcon';
import '@alfalab/icons-glyph/ChevronRightCompactSIcon';
import '../scroll-controls/utils.js';

function getBorderRadius(shape, size, isMobile) {
    if (shape === 'rounded') {
        return 99;
    }
    if (size === 'xxs')
        return isMobile ? 8 : 6;
    if (size === 'xs' || size === 's')
        return isMobile ? 12 : 8;
    return isMobile ? 16 : 4;
}
var SecondaryTabList = function (_a) {
    var _b = _a.styles, styles = _b === void 0 ? {} : _b, className = _a.className, containerClassName = _a.containerClassName, size = _a.size, _c = _a.titles, titles = _c === void 0 ? [] : _c, _d = _a.selectedId, selectedId = _d === void 0 ? titles.length ? titles[0].id : undefined : _d, _e = _a.scrollable, scrollable = _e === void 0 ? true : _e, fullWidthScroll = _a.fullWidthScroll, _f = _a.tagSize, tagSize = _f === void 0 ? 'xs' : _f, onChange = _a.onChange, dataTestId = _a.dataTestId, TagComponent = _a.TagComponent, platform = _a.platform, _g = _a.tagShape, tagShape = _g === void 0 ? 'rounded' : _g, tagView = _a.tagView, inlineStyle = _a.inlineStyle, showSkeleton = _a.showSkeleton, skeletonProps = _a.skeletonProps;
    var _h = useTabs({
        titles: titles,
        selectedId: selectedId,
        onChange: onChange,
    }), focusedTab = _h.focusedTab, selectedTab = _h.selectedTab, getTabListItemProps = _h.getTabListItemProps;
    var renderContent = function () {
        var _a;
        if (!TagComponent)
            return null;
        return (React.createElement("div", { role: 'tablist', "data-test-id": dataTestId, className: cn(styles.component, className, size && styles[size], (_a = {},
                _a[styles.fullWidthScroll] = fullWidthScroll,
                _a)) }, titles.map(function (item, index) {
            if (item.hidden)
                return null;
            var renderTab = function () { return (React.createElement(TagComponent, __assign({}, getTabListItemProps(index), { shape: tagShape, view: tagView, key: item.id, className: cn(styles.title, item.toggleClassName), checked: item.id === selectedId, size: tagSize, rightAddons: item.rightAddons }), item.title)); };
            return showSkeleton ? (React.createElement(Skeleton, __assign({}, skeletonProps, { className: cn(styles.skeleton, skeletonProps === null || skeletonProps === void 0 ? void 0 : skeletonProps.className), key: item.id, visible: true, style: __assign(__assign({}, skeletonProps === null || skeletonProps === void 0 ? void 0 : skeletonProps.style), { borderRadius: getBorderRadius(tagShape, tagSize, platform === 'mobile') }) }), renderTab())) : (renderTab());
        })));
    };
    return scrollable ? (React.createElement(ScrollableContainer, { activeChild: focusedTab || selectedTab, containerClassName: containerClassName, fullWidthScroll: fullWidthScroll, view: 'secondary', size: size, platform: platform, inlineStyle: inlineStyle, showSkeleton: showSkeleton }, renderContent())) : (React.createElement("div", { className: cn(styles.container, containerClassName), style: inlineStyle }, renderContent()));
};

export { SecondaryTabList };
